import React from "react";
import HelmetSeo from "../../components/Site/Reusable/HelmetSeo";
import Hero from "../../components/Site/Reusable/Hero";
import SpacingItem from "../../components/Site/Reusable/SpacingItem";
import TitleDescription from "../../components/Site/Reusable/TitleDescription";
import CyberInfo from "../../components/Site/Reusable/CyberInfo";

import "../../assets/siem.scss";
import "../../assets/services.scss";
import RelatedServices from "../../components/Site/Reusable/RelatedServices";
import GuardiumService from "../../components/Site/Sections/TehnologySolutions/GuardiumService";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchSeoListItems } from "../../actions/Site/global";

const IbmGuardium = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const { dataPagesListSeo } = useSelector((state) => state.globalReducer);

  useEffect(() => {
    dispatch(fetchSeoListItems(9));
  }, [dispatch]);
  return (
    <div className="page-holder-main-content">
      <HelmetSeo
        title={dataPagesListSeo.length > 0 && dataPagesListSeo[0].acTitle}
        description={
          dataPagesListSeo.length > 0 && dataPagesListSeo[0].acDescription
        }
        keywords={dataPagesListSeo.length > 0 && dataPagesListSeo[0].acKeywords}
      />
      <Hero title={t("ibm.title")} img={`guardium-hero.png`} />
      <SpacingItem />
      <CyberInfo text={t("ibm.desc")} />
      <TitleDescription
        title={t("ibm.title2")}
        description={t("ibm.desc2")}
        button={t("ibm.button2")}
        link={`services#protectionOfDatabases`}
      />
      <GuardiumService t={t} />
      <RelatedServices
        title={t("related.title")}
        text1={t("related.ibm.title1")}
        link1={t("related.ibm.link1")}
        text2={t("related.ibm.title2")}
        link2={t("related.ibm.link2")}
        text3={t("related.ibm.title3")}
        link3={t("related.ibm.link3")}
        buttonTitle={t("related.button")}
      />
    </div>
  );
};

export default IbmGuardium;
